import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { HiMenu, HiX } from 'react-icons/hi';
import { 
  ComputerDesktopIcon, 
  SignalIcon, 
  SpeakerWaveIcon, 
  FilmIcon, 
  WrenchIcon,
  RocketLaunchIcon
} from '@heroicons/react/24/outline';
import AyelLogo from '../../Assets/images/ayel_logo.png';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const products = [
    {
      name: 'Navigation Systems',
      description: 'Advanced navigation systems for marine vessels',
      href: '/products/navigation',
      icon: ComputerDesktopIcon
    },
    {
      name: 'Communication',
      description: 'Maritime communication solutions',
      href: '/products/communication',
      icon: SignalIcon
    },
    {
      name: 'Internal Communication',
      description: 'Vessel internal communication systems',
      href: '/products/internal-communication',
      icon: SpeakerWaveIcon
    },
    {
      name: 'Entertainment',
      description: 'Marine entertainment systems',
      href: '/products/entertainment',
      icon: FilmIcon
    },
    {
      name: 'Others',
      description: 'Additional marine equipment and solutions',
      href: '/products/others',
      icon: WrenchIcon
    },
  ];

  const brands = [
    { name: 'AEP MARİNE', link: 'https://www.aepmarineparts.com/' },
    { name: 'OVA MARİNELİTE', link: 'https://www.ova.com.cn/zlxz' },
    
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 font-tt-lakes
      ${isScrolled ? 'bg-white backdrop-blur-md shadow-lg' : 'bg-white'}
    `}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
        
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2 group">
            <img 
                src={AyelLogo} 
                alt="Ayel Marine Logo" 
                className="h-12 w-auto object-contain transition-transform duration-300 hover:scale-105"
              />
            </Link>
          </div>

         
          <div className="hidden md:flex items-center space-x-1">
            <Link 
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300
                ${isActive('/') 
                  ? 'text-marine-red bg-red-50' 
                  : 'text-marine-black hover:text-marine-red hover:bg-red-50'}`}
            >
              Home
            </Link>

           
            <Menu as="div" className="relative">
              {({ open }) => (
                <>
                  {/* <Menu.Button className={`px-4 py-2 rounded-lg text-sm font-medium inline-flex items-center space-x-1 transition-all duration-300
                    ${open 
                      ? 'text-marine-red bg-red-50' 
                      : 'text-marine-black hover:text-marine-red hover:bg-red-50'}`}
                  >
                    <span>Products</span>
                    <svg
                      className={`ml-2 h-4 w-4 transition-transform duration-300 ${open ? 'rotate-180' : ''}`}
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </Menu.Button> */}

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 translate-y-1"
                  >
                    <Menu.Items className="absolute left-0 mt-2 w-80 origin-top-left rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                     
                    </Menu.Items>
                  </Transition>
                </>
              )}
            </Menu>

            

            {['services', 'about', 'contact'].map((item) => (
              <Link
                key={item}
                to={`/${item}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300
                  ${isActive('/' + item) 
                    ? 'text-marine-red bg-red-50' 
                    : 'text-marine-black hover:text-marine-red hover:bg-red-50'}`}
              >
                {item.charAt(0).toUpperCase() + item.slice(1)}
              </Link>
            ))}
          </div>

          
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 rounded-lg text-marine-black hover:text-marine-red hover:bg-red-50 transition-colors duration-300"
            >
              {isOpen ? (
                <HiX className="w-6 h-6" />
              ) : (
                <HiMenu className="w-6 h-6" />
              )}
            </button>
          </div>
          <div className="relative">
            <button 
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center h-10 mt-5 px-4 bg-red-500 rounded-lg text-sm font-medium transition-all duration-300 text-white hover:text-marine-red hover:bg-red-50"
            >
              <RocketLaunchIcon className="h-5 w-5 mr-1" />
              Distributorships
            </button>

            {isDropdownOpen && (
              <div className="absolute right-[-30px] mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                <div className="py-1" role="menu" aria-orientation="vertical">
                  {brands.map((brand, index) => (
                    <a
                      key={index}
                      href={brand.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-marine-red"
                      role="menuitem"
                    >
                      {brand.name}
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Transition
        show={isOpen}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        
        <div className="md:hidden absolute top-20 left-0 right-0 bg-white shadow-lg">
          <div className="px-4 pt-2 pb-3 space-y-1">
            
            <Link 
              to="/"
              className={`block px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300
                ${isActive('/') 
                  ? 'text-marine-red bg-red-50' 
                  : 'text-marine-black hover:text-marine-red hover:bg-red-50'}`}
            >
              Home
            </Link>
            
            

            {['services', 'about', 'contact'].map((item) => (
              <Link
                key={item}
                to={`/${item}`}
                className={`block px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300
                  ${isActive('/' + item)
                    ? 'text-marine-red bg-red-50'
                    : 'text-marine-black hover:text-marine-red hover:bg-red-50'}`}
              >
                {item.charAt(0).toUpperCase() + item.slice(1)}
              </Link>
            ))}
          </div>
          
        </div>
      </Transition>
    </nav>
  );
}

export default Navbar;